import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Section from 'components/Section';
import PassengerDocuments from 'components/PassengerDocuments';

import { OrderEditMainDocuments_order$key } from '__generated__/OrderEditMainDocuments_order.graphql';
import { ReactNode } from 'react';

type Props = {
  order: OrderEditMainDocuments_order$key;
};

const OrderEditMainDocuments = (props: Props) => {
  const { orderRooms } = useFragment(
    graphql`
      fragment OrderEditMainDocuments_order on Order {
        orderRooms {
          slots {
            id
            ...PassengerDocuments_slot
          }
        }
      }
    `,
    props.order
  );

  const passengers: ReactNode[] = [];

  orderRooms.forEach((orderRoom, i) => {
    orderRoom.slots.forEach((slot, k) => {
      passengers.push(<PassengerDocuments key={slot.id} slot={slot} />);
    });
  });

  return (
    <Section id="documents" title="Keleivių dokumentai">
      {passengers}
    </Section>
  );
};

export default OrderEditMainDocuments;
